import type { Root } from 'mdast';
import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';

// Matches an `[ID:<token>]` citation marker plus any leading whitespace, so
// `Step one [ID:2] then…` collapses to `Step one then…` (single space).
// The id token is any non-`]`, non-whitespace string, so both numeric markers
// (`[ID:1]`) and the literal `[ID:external]` are matched.
const CITATION_REGEX = /\s*\[ID:[^\]\s]+\]/g;

/**
 * Walks markdown text nodes and strips `[ID:N]` citation markers entirely.
 * Markers are not rendered inline; citations are collected per-message by the
 * citation store and surfaced once in the `CitationFooter` below the assistant
 * message body.
 */
export const remarkCitations: Plugin<[], Root> = () => {
  return (tree) => {
    visit(tree, 'text', (node) => {
      if (typeof node.value !== 'string') return;
      if (!node.value.includes('[ID:')) return;
      node.value = node.value.replace(CITATION_REGEX, '');
    });
  };
};
